//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { PurchaseOption } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import { PrepaidPurchaseOptionsTableRowContent } from '@campaigns/components/shared/prepaid-purchase-options/prepaid-purchase-options-table-row/PrepaidPurchaseOptionsTableRowContent';
import { WIDTH_CHECKBOX } from '@campaigns/constants/sampling/SamplingCampaignRequestConstants';
import { SAMPLING_CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/sampling/SamplingCampaignsTrackingId';
import { TableDataCell } from '@components/organisms/table/TableDataCell';
import { TableRow } from '@components/organisms/table/TableRow';
import { Checkbox } from '@components/primitives/checkbox/Checkbox';

interface PrepaidPurchaseOptionsTableRowEditableProps {
  isChecked: boolean;
  onToggle?: () => void;
  purchaseOption: PurchaseOption;
}

export const PrepaidPurchaseOptionsTableRowEditable = ({
  isChecked,
  onToggle,
  purchaseOption,
}: PrepaidPurchaseOptionsTableRowEditableProps) => {
  return (
    <TableRow>
      <CheckboxCell scope='row'>
        <Checkbox
          checked={isChecked}
          onCheckedChange={onToggle}
          trackingId={
            SAMPLING_CAMPAIGNS_TRACKING_ID.CAMPAIGN_REQUEST_PURCHASE_OPTIONS_CHECKBOX
          }
        >
          <Checkbox.Indicator>
            {isChecked ? (
              <Checkbox.Icon name='checkmark' />
            ) : (
              <Checkbox.Icon name='collapse' />
            )}
          </Checkbox.Indicator>
        </Checkbox>
      </CheckboxCell>
      <PrepaidPurchaseOptionsTableRowContent purchaseOption={purchaseOption} />
    </TableRow>
  );
};

const CheckboxCell = styled(TableDataCell)`
  ${WIDTH_CHECKBOX}
`;
